<!--
地図出力画面
URL：/deviceMap
-->

<template>
  <div>
    <v-container v-show="mapDisplay">
      <l-map :key="mapKey" ref="map" style="height: 700px; width: 100%" :zoom="zoom" :center="center"
             :min-zoom="minZoom" :max-zoom="maxZoom">
        <l-tile-layer :url="url">test</l-tile-layer>
        <l-marker v-for="(marker, index) in markerPlaces" :key="index" :lat-lng="marker.latlon">
          <l-popup :options="{ autoClose: false, closeOnClick: false }">
            <div>
            <div class="primary--text" :style="{ ...popupTextStyle1, textAlign: 'center' }">【{{ marker.name }}】</div>
            <div class="primary--text" :style="popupTextStyle1">取得日時: {{ marker.date }}</div>
            <div class="primary--text" :style="popupTextStyle2">{{ marker.titles.title1 }}</div>
            <div class="primary--text" :style="popupTextStyle2">{{ marker.titles.title2 }}</div>
            <div class="primary--text" :style="popupTextStyle2">{{ marker.titles.title3 }}</div>
            </div>
          </l-popup>
        </l-marker>
      </l-map>
    </v-container>
  </div>
</template>

<script>
import "leaflet/dist/leaflet.css";
import {LMap, LTileLayer, LMarker, LPopup} from "vue2-leaflet";
import Api from "@/logic/api/api.js";
import AlertBuilder from "../../logic/common/alert-contents";
import valueMapper from "../../logic/common/value-mapper";
import {latLng} from "leaflet/src/geo";
import moment from 'moment';


export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
  },
  data: () => ({
    mapDisplay: false,
    url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
    zoom: 12,
    minZoom: 9,
    maxZoom: 18,
    center: [34.27, 132.41],
    markerPlaces: [],
    mapKey: 0,
    popupTextStyle1: {
      fontSize: '25px' // 吹き出しの文字サイズを指定
    },
    popupTextStyle2: {
      fontSize: '25px' // 吹き出しの文字サイズを指定
    },
    positions: [
      [35.6896, 139.6918],
      [35.6896, 139.6918],
      [35.8572, 139.6490]
    ]
  }),
  beforeMount() {
    this.displayDevicesMap()
  },
  watch: {
    '$refs.map.$el.clientWidth'(newWidth) {
      if (newWidth <= 1160) {
        this.zoom = 15;
      }
    }
  },
  methods: {
    displayDevicesMap() {
      let vm = this
      let postData = {};
      this.$store.commit("setWaiting", true);

      // 現在水温情報集計APIからうみログデバイス一覧情報を取得
      Api.call("/umilog/sensorlogs/coordinates", postData)
          .then((result) => {
            vm.$store.commit("setWaiting", false);
            // デバイスが存在する場合はデバイス一覧を作成
            if (result.count > 0) {
              vm.setMapdata(result);
            }
          })
          .catch((error) => {
            vm.$store.commit("setWaiting", false);
            const message = valueMapper
                .map({
                  401: AlertBuilder.error("データの更新に失敗しました"),
                })
                .getOrElse(error.status, AlertBuilder.invalid());
            if (message.isInvalid) {
              Api.resolve(error);
            } else {
              vm.showMessage(message);
            }
          })
    },

    //leafletの地図表示用データ
    setMapdata(result) {

      let gps1
      let gps2
      let top_wtr
      let mid_wtr
      let btm_wtr
      let formattedDateTime
      let position
      let datalist = []
      let datatext = {}
      let positionlist = []
      let gpslist = []
      for (const data of result.response_list) {

        if (data["top_wtr"] != null) {
          top_wtr = data["top_wtr"];
        } else {
          top_wtr = "--";
        }
        if (data["mid_wtr"] != null) {
          mid_wtr = data["mid_wtr"];
        } else {
          mid_wtr = "--";
        }
        if (data["btm_wtr"] != null) {
          btm_wtr = data["btm_wtr"];
        } else {
          btm_wtr = "--";
        }

        const str = data["gps"];
        const itemData = str.split(',');
        gps1 = Number(itemData[0])
        gps2 = Number(itemData[1])
        if (gpslist.includes(str)) {
          gps1 += 0.0005;
          gps2 += 0.0005;
          gpslist.push(String(gps1) + "," + String(gps2))
        } else {
          gpslist.push(str);
        }

        if (data["update_date"] != null) {
          formattedDateTime = moment(data["update_date"]).format('Y/M/D HH:mm');
        } else {
          formattedDateTime = "--";
        }

        datatext = {
          id: data["device_id"],
          name: data["name"],
          date: formattedDateTime,
          latlon: latLng(gps1, gps2),
          titles: {
            title1: "表層：" + top_wtr + "℃",
            title2: "中層：" + mid_wtr + "℃" ,
            title3: "底層：" + btm_wtr + "℃",
          },
        }
        position = [gps1,gps2],
        positionlist.push(position)
        datalist.push(datatext)
        datatext = {}
      }
      console.log(positionlist);
      console.log(datalist);
      this.mapKey++;
      this.markerPlaces = datalist;
      this.$nextTick(() => {
        const map = this.$refs.map;
        map.fitBounds(positionlist);
      });
      this.mapDisplay = true;
    },
  },
};
</script>

<style></style>